// extracted by mini-css-extract-plugin
export default {"themeToggle":"ThemeToggle_themeToggle__PqZrY","toggleIcon":"ThemeToggle_toggleIcon__ElOOv"};